import { loadGoogleTagManager } from './google-tag-manager';
import { runWhenIdleOrInteraction } from './schedule-deferred';

/**
 * Schedules all deferred third-party marketing tags so they load after the app
 * is interactive instead of blocking initial paint. Call once after the app is
 * mounted.
 *
 * Currently this covers Google Tag Manager (and the GA4/Ads/FB Pixel/TikTok
 * tags it cascades to). Google Analytics' own `gtag/js` defers itself inside
 * `googleAnalyticsLib.init`. Exponea/Bloomreach stays inline in `index.html`
 * because its anti-flicker web layers must run before first paint.
 */
export const initDeferredThirdPartyTags = (): void => {
  runWhenIdleOrInteraction(loadGoogleTagManager);
};

export { loadGoogleTagManager } from './google-tag-manager';
export { runWhenIdleOrInteraction } from './schedule-deferred';
